import baseContainer from './_baseContainer';
import ContentPane from '../components/contentpane/ContentPane';

const mapStateToProps = state => ({
  selectedTab: state.tab.selectedTab,
  tabs: state.tab.tabs,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default baseContainer(mapStateToProps, mapDispatchToProps)(ContentPane);
